import { useContext } from 'react'
import { DataAccessContext, type DataAccessContextValue } from './DataAccessContextDef'

export function useDataAccessContext(): DataAccessContextValue {
  return useContext(DataAccessContext)
}
